export const ITEM_CATEGORIES = {
  CURRENCY: "currency",
}

export const CURRENCY_TYPES = {
  PG_POINTS: "pg-points",
  PB_CREDIT: "pb-credit",
  INSTAPRO_TOKENS: "instapro-tokens",
}



// WEBPACK FOOTER //
// ./src/store/user/inventory/inventory.constants.js